import React, { useMemo } from 'react';
import { Navigation } from 'lucide-react';
import { getAllStagesForNavigator } from '../lib/scriptHelpers';

export default function ScriptNavigator({ script, onNavigate, currentUUID }) {
  const items = useMemo(() => {
    return getAllStagesForNavigator(script);
  }, [script]);

  const handleChange = (e) => {
    const selectedUUID = e.target.value;
    if (selectedUUID && onNavigate) {
      onNavigate(selectedUUID);
      // Сбрасываем select на пустое значение после навигации
      e.target.value = '';
    }
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-20 right-6 z-40 bg-white/95 backdrop-blur-sm border border-gray-200 rounded-lg px-3 py-2 shadow-md flex items-center gap-2 max-w-xs">
      <Navigation className="text-gray-600 flex-shrink-0" size={18} />
      <select
        onChange={handleChange}
        className="flex-1 min-w-0 px-2 py-1.5 border border-gray-200 rounded-md text-sm text-gray-700 bg-white cursor-pointer transition-all hover:border-blue-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
      >
        <option value="">Навигация...</option>
        {items.map((item, idx) => (
          <option 
            key={item.uuid || idx} 
            value={item.uuid}
            className={item.type === 'stage' ? 'font-semibold' : 'pl-4'}
          >
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
}
